var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7678 20.7678C38.7441 19.7915 38.7441 18.2085 37.7678 17.2322L21.8579 1.32233C20.8816 0.34602 19.2986 0.34602 18.3223 1.32233C17.346 2.29864 17.346 3.88155 18.3223 4.85786L32.4645 19L18.3223 33.1421C17.346 34.1184 17.346 35.7014 18.3223 36.6777C19.2986 37.654 20.8816 37.654 21.8579 36.6777L37.7678 20.7678ZM0 21.5H36V16.5H0L0 21.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.7b2598729ef9b9ca6c3d45e9ea28db73.svg";
export { ForwardRef as ReactComponent };